// Our bootleg way of adding entries. Too lazy to make a backend, not lazy enough to build an entry from an object

export const artCards = {
  cardName1: {
    title:`Blaise Rage`,
    desktopThumbnail: `/images/art/Blaise_Rage_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Blaise_Rage_MThumbnail.webp`,
    image:`/images/art/Blaise_Rage.jpg`,
    description:`Style experiment of my character Blaise.`
  },
  cardName2: {
    title:`Ornstein`,
    desktopThumbnail: `/images/art/Ornstein_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Ornstein_MThumbnail.webp`,
    image:`/images/art/Ornstein.jpg`,
    description:`Brush and rendering test of one of my favorite bosses from Dark Souls.`
  },
  cardName3: {
    title:`Squid Kid Shxtou`,
    desktopThumbnail: `/images/art/Shoto_Squid_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Shoto_Squid_MThumbnail.webp`,
    image:`/images/art/Shoto_Squid.jpg`,
    description:`Splatoon squid version of the stream Shxtou`
  },
  cardName4: {
    title:`Wust (Character Commission)`,
    desktopThumbnail: `/images/art/Wust_Samitaire_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Wust_Samitaire_MThumbnail.webp`,
    image:`/images/art/Wust_Samitaire.jpg`,
    description:`Commission I did for @Samitaire of their character.`
  },

  cardName5: {
    title:`Arkie the Archivist Angel`,
    desktopThumbnail:`/images/art/Arkie_Angel_Thumbnail.webp`, // Consider smaller like 410 x 698 || 320 x 512
    mobileThumbnail:`/images/art/Arkie_Angel_MThumbnail.webp`,
    image:`/images/art/Arkie_Angel.jpg`,
    description:`Render, style and design exercise of an angel type character.`
  },
  cardName6: {
    title:`Sasha from Animal Crossing`,
    desktopThumbnail: `/images/art/Sasha_AC_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Sasha_AC_MThumbnail.webp`,
    image:`/images/art/Sasha_AC.jpg`,
    description:`Style exploration of a character from Animal Crossing, Sasha.`
  },
  cardName7: {
    title:`Zerphyr`,
    desktopThumbnail: `/images/art/Zephyr_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Zephyr_MThumbnail.webp`,
    image:`/images/art/Zephyr.jpg`,
    description:`Style and render test of my character Zephyr.`
  },
  cardName8: {
    title:`Lucifer`,
    desktopThumbnail: `/images/art/Lucifer_Unleashed_Thumbnail.webp`, 
    mobileThumbnail: `/images/art/Lucifer_Unleashed_MThumbnail.webp`,
    image:`/images/art/Lucifer_Unleashed.jpg`,
    description:`Assignment for an art class, depicting my version of the mythological angel, Lucifer.`
  },
  }